import { isAfter, isBefore, startOfDay } from 'date-fns';
import { HabitSchedule } from 'shared/types/habit-schedule';
import { Timestamp } from 'shared/types/timestamp';
import { getActualScheduleStartDate } from 'shared/utils/schedules';

export const getActiveSchedule = (
  schedules: HabitSchedule[] | undefined | null,
  today: Timestamp,
) => {
  const todayStart = startOfDay(today);

  return schedules
    ?.filter(
      (schedule) =>
        !isAfter(getActualScheduleStartDate(schedule), todayStart) &&
        (!schedule.endDate || !isBefore(schedule.endDate, todayStart)),
    )
    .sort(
      (scheduleA, scheduleB) =>
        scheduleB.startDate.getTime() - scheduleA.startDate.getTime(),
    )[0];
};
